import { atom, selector } from 'recoil';
import type { RecoilState } from 'recoil';
import {
  localStoragePersisterEffect,
  broadcastChannelSynchronizerEffect,
  localStorageSynchronizerEffect,
} from 'utils/recoilEffects';
import { SRNA_PERSIST_TOKEN } from 'config/constants';

export type ReadCaseState = {
  workstationID: string | null;
};

export const readCaseState: RecoilState<ReadCaseState> = atom<ReadCaseState>({
  key: `${SRNA_PERSIST_TOKEN}readCaseState`,
  default: {
    workstationID: null,
  },
  effects: [localStoragePersisterEffect(), localStorageSynchronizerEffect()],
});

export interface ExternalLaunchState {
  isExternalLaunch: boolean;
  reporterOnly: boolean;
  patientJacketOnRead: boolean;
  launchedCaseSmid: string | null;
  launchedAt: number | null;
}

export const externalLaunchStateDefault: ExternalLaunchState = {
  isExternalLaunch: false,
  reporterOnly: false,
  patientJacketOnRead: false,
  launchedCaseSmid: null,
  launchedAt: null,
};

export const externalLaunchState: RecoilState<ExternalLaunchState> = atom<ExternalLaunchState>({
  key: `${SRNA_PERSIST_TOKEN}externalLaunchState`,
  default: externalLaunchStateDefault,
  effects: [localStoragePersisterEffect(), broadcastChannelSynchronizerEffect()],
});

export const isReporterOnlyExternalLaunchSelector = selector<boolean>({
  key: 'isReporterOnlyExternalLaunch',
  get: ({ get }) => {
    const state = get(externalLaunchState);
    return state.isExternalLaunch && state.reporterOnly;
  },
});
